// extracted by mini-css-extract-plugin
export default {"reminder":"styles_reminder__KIGbg","critical":"styles_critical__rNEh3","expired":"styles_expired__uNXpR","renewLink":"styles_renewLink__CLKx+"};